// extracted by mini-css-extract-plugin
module.exports = {"header":"SidebarHeaderModerator_header__104Js","title":"SidebarHeaderModerator_title__N7sqv"};